export function getRuleTimeFormatted(hours?: number, minutes?: number) {
  if (hours !== undefined && minutes !== undefined) {
    const hoursFormatted = hours < 10 ? `0${hours}` : String(hours);
    const minutesFormatted = minutes < 10 ? `0${minutes}` : String(minutes);
    return `${hoursFormatted}:${minutesFormatted}`;
  }

  return '';
}
